/**
 * Checks if any of the selected highlights are shared between multiple names.
 *
 * @param {Object} params - The parameters for the function.
 * @param {Array} params.mainSelectedHighlights - The main highlights.
 * @param {Array} params.splitScreenSelectedHighlights - The split screen highlights.
 * @param {Object} params.types - Array of zion SLS types.
 * @param {string} params.fieldType - The type of the field.
 * @param {string} params.personId - The ID of the selected person.
 * @returns {boolean} - Returns true if any highlight is shared and either the field or element is shareable.
 */
export const checkIfSharedHighlights = ({
  mainSelectedHighlights,
  splitScreenSelectedHighlights,
  types,
  fieldType,
  personId,
}) => {
  const attachedHighlights = [...mainSelectedHighlights, ...splitScreenSelectedHighlights]
  const fieldTypeObject = types.fields.find((type) => type.fieldType === fieldType)
  const fieldIsShareable = !fieldTypeObject?.singleSuper

  const elementIsShareable = !types.elements.find((type) => type.elementType === fieldTypeObject.elementTypes[0])
    ?.singleSuper

  const anyHighlightIsTaken = attachedHighlights?.find((highlight) => {
    // Filtering empty, null or undefined personIds
    const originalPersonIds = highlight.originalHighlight?.personIds.filter(Boolean)

    return originalPersonIds?.length > 0 && !originalPersonIds?.includes(personId)
  })

  return !!anyHighlightIsTaken && (fieldIsShareable || elementIsShareable)
}
